import React, { useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Button from '../../components/base/Button';

const GalleryPage: React.FC = () => {
  const [activeFilter, setActiveFilter] = useState('sve');
  const [selectedImage, setSelectedImage] = useState<string | null>(null);

  const filters = [
    { id: 'sve', name: 'Sve' },
    { id: 'stambeni', name: 'Stambeni Objekti' },
    { id: 'poslovni', name: 'Poslovni Objekti' },
    { id: 'industrijski', name: 'Industrijski' },
    { id: 'automatski', name: 'Automatizovani Sistemi' }
  ];

  const galleryItems = [
    {
      id: 1,
      category: "stambeni",
      image: "https://readdy.ai/api/search-image?query=luxury%20residential%20garage%20door%20installation%20elegant%20villa%20modern%20sectional%20door%20white%20background%20professional%20quality%20workmanship%20high-end%20home%20beautiful%20architecture&width=600&height=400&seq=17&orientation=landscape"
    },
    {
      id: 2,
      title: "Poslovna Zgrada Novi Sad",
      location: "Novi Sad",
      category: "poslovni",
      type: "Komercijalna vrata",
      image: "https://readdy.ai/api/search-image?query=commercial%20business%20building%20garage%20door%20installation%20professional%20sectional%20doors%20office%20complex%20modern%20architecture%20quality%20installation%20service&width=600&height=400&seq=18&orientation=landscape"
    },
    {
      id: 3,
      title: "Industrijski Kompleks",
      location: "Pančevo",
      category: "industrijski",
      type: "Industrijska segmentna vrata",
      image: "https://i.postimg.cc/DZTH9C8N/viber-image-2023-02-16-11-54-42-071-1-e1677432526916.jpg"
    },
    {
      id: 4,
      title: "Vila sa Automatskim Sistemom",
      location: "Zemun",
      category: "automatski",
      type: "Automatska segmentna vrata",
      image: "https://readdy.ai/api/search-image?query=automatic%20garage%20door%20system%20installation%20modern%20villa%20remote%20controlled%20sectional%20door%20professional%20automation%20technology%20smart%20home%20garage&width=600&height=400&seq=20&orientation=landscape"
    },
    {
      id: 5,
      title: "Moderna Kuća Vračar",
      location: "Beograd",
      category: "stambeni",
      type: "Dizajnerska vrata",
      image: "https://i.postimg.cc/QdcJJCC5/rolovrata1.png"
    },
    {
      id: 7,
      title: "Fabrika Kragujevac",
      location: "Kragujevac",
      category: "industrijski",
      type: "Protivpožarna vrata",
      image: "https://readdy.ai/api/search-image?query=industrial%20factory%20fire-rated%20garage%20doors%20professional%20installation%20manufacturing%20facility%20safety%20doors%20industrial%20complex%20heavy%20duty%20sectional%20doors&width=600&height=400&seq=23&orientation=landscape"
    },
    {
      id: 8,
      title: "Smart Home Senjak",
      location: "Beograd",
      category: "automatski",
      type: "Wi-Fi kontrolisana vrata",
      image: "https://i.postimg.cc/66Djgjgr/big-160746813-688ce0ec19c804-54681100image.webp"
    },
    {
      id: 9,
      title: "Porodična Kuća Niš",
      location: "Niš",
      category: "stambeni",
      type: "Izolovana segmentna vrata",
      image: "https://readdy.ai/api/search-image?query=family%20house%20garage%20door%20installation%20insulated%20sectional%20door%20residential%20property%20professional%20quality%20workmanship%20suburban%20home%20garage%20installation&width=600&height=400&seq=25&orientation=landscape"
    },
    {
      id: 10,
      title: "Hotel Kompleks",
      location: "Zlatibor",
      category: "poslovni",
      type: "Hotelska garaža",
      image: "https://readdy.ai/api/search-image?query=hotel%20garage%20facility%20professional%20sectional%20door%20installation%20hospitality%20building%20commercial%20garage%20doors%20quality%20service%20hotel%20complex&width=600&height=400&seq=26&orientation=landscape"
    },
    {
      id: 11,
      title: "Logistički Centar",
      location: "Inđija",
      category: "industrijski",
      type: "Brza industrijska vrata",
      image: "https://readdy.ai/api/search-image?query=logistics%20center%20industrial%20garage%20doors%20fast%20sectional%20doors%20warehouse%20facility%20professional%20installation%20distribution%20center%20commercial%20facility&width=600&height=400&seq=27&orientation=landscape"
    },
    {
      id: 12,
      title: "Premium Vila Topčider",
      location: "Beograd",
      category: "automatski",
      type: "Premium automatika",
      image: "https://i.postimg.cc/D02ZwdYL/6Bg-QLq-FSzfss-Sb6WZzc-U.jpg"
    }
  ];

  const filteredItems = activeFilter === 'sve' 
    ? galleryItems 
    : galleryItems.filter(item => item.category === activeFilter);

  return (
    <div className="min-h-screen">
      <Header />
      
      {/* Hero Section */}
      <section className="relative pt-24 pb-16 min-h-[50vh] flex items-center">
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: `url('https://readdy.ai/api/search-image?query=garage%20door%20gallery%20showcase%20multiple%20installations%20professional%20workmanship%20various%20sectional%20doors%20portfolio%20quality%20installations%20diverse%20projects&width=1920&height=600&seq=29&orientation=landscape')`
          }}
        ></div>
        <div className="absolute inset-0 bg-gradient-to-r from-black/60 to-black/30"></div>
        
        <div className="relative z-10 container mx-auto px-6">
          <div className="max-w-3xl">
            <h1 className="text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
              Galerija Naših Radova
            </h1>
            <p className="text-xl lg:text-2xl text-gray-200 mb-8 leading-relaxed">
              Pogledajte kvalitet našeg rada kroz brojne uspešno realizovane projekte
            </p>
          </div>
        </div>
      </section>

      {/* Filter Navigation */}
      <section className="py-8 bg-white border-b">
        <div className="container mx-auto px-6">
          <div className="flex flex-wrap justify-center gap-4">
            {filters.map((filter) => (
              <button
                key={filter.id}
                onClick={() => setActiveFilter(filter.id)}
                className={`px-6 py-3 rounded-full font-medium transition-all duration-300 ${
                  activeFilter === filter.id
                    ? 'bg-red-600 text-white shadow-lg'
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                }`}
              >
                {filter.name}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredItems.map((item) => (
              <div
                key={item.id}
                className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 cursor-pointer"
                onClick={() => setSelectedImage(item.image)}
              >
                <div className="relative h-80 w-full overflow-hidden group">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 hover:opacity-100 transition-opacity duration-300">
                    <div className="absolute bottom-4 left-4">
                      <div className="bg-white/20 backdrop-blur-sm px-3 py-1 rounded-full">
                        <span className="text-white text-sm font-medium">Pogledaj</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {filteredItems.length === 0 && (
            <div className="text-center py-16">
              <i className="ri-image-line text-6xl text-gray-300 mb-4"></i>
              <h3 className="text-2xl font-bold text-gray-600 mb-2">
                Nema rezultata
              </h3>
              <p className="text-gray-500">
                Pokušajte sa drugim filterom
              </p>
            </div>
          )}
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-16 bg-red-600">
        <div className="container mx-auto px-6">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 text-center text-white">
            <div>
              <div className="text-4xl lg:text-5xl font-bold mb-2">500+</div>
              <div className="text-red-100">Realizovanih Projekata</div>
            </div>
            <div>
              <div className="text-4xl lg:text-5xl font-bold mb-2">15+</div>
              <div className="text-red-100">Godina Iskustva</div>
            </div>
            <div>
              <div className="text-4xl lg:text-5xl font-bold mb-2">100%</div>
              <div className="text-red-100">Zadovoljnih Klijenata</div>
            </div>
            <div>
              <div className="text-4xl lg:text-5xl font-bold mb-2">24/7</div>
              <div className="text-red-100">Podrška</div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-6 text-center">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Želite da Vaš Projekat Bude Sledeći?
          </h2>
          <p className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto">
            Kontaktirajte nas danas za besplatnu procenu i počnite put ka novim kvalitetnim segmentnim vratima
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button 
              variant="primary" 
              size="lg"
              icon="ri-phone-line"
              href="tel:+381600706072"
            >
              Pozovite Sada
            </Button>
            <Button 
              variant="outline" 
              size="lg"
              to="/kontakt"
              icon="ri-mail-line"
            >
              Pošaljite Upit
            </Button>
          </div>
        </div>
      </section>

      {/* Lightbox Modal */}
      {selectedImage && (
        <div 
          className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4"
          onClick={() => setSelectedImage(null)}
        >
          <div className="relative max-w-4xl max-h-full">
            <img
              src={selectedImage}
              alt="Gallery image"
              className="max-w-full max-h-full object-contain rounded-lg"
            />
            <button
              onClick={() => setSelectedImage(null)}
              className="absolute top-4 right-4 w-10 h-10 bg-white/20 hover:bg-white/30 backdrop-blur-sm rounded-full flex items-center justify-center text-white transition-colors"
            >
              <i className="ri-close-line text-xl"></i>
            </button>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
};

export default GalleryPage;